<template>  

  <div class="main-body">
   <MainHeader/>

   <div id="main-content-list">
    <!---<button onclick="moreContent()">More Content</button>-->



    <TopAdSense/>

    <div class="first-title-blck">
      <div v-if="firstReviewTitle.length>0" class="review-title">
        <span v-if="parseInt(commentPageNum(0)) > 0"><a class="title-link" :href="'../reviews/?p='+reviewId">re: {{firstReviewTitle}}</a></span>
        <span v-else>{{firstReviewTitle}}</span>
      </div>
    </div>


  <div v-for="(review,i) in contentList" :key="review">

    
      
      <div v-if="i>0" class="search-form-blck">
       <SearchBlock :post_id="review['main'][0].ID"/>
      </div>

     <div :id="'content-blck-'+review['main'][0].ID" :class="'content-blck'+firstContentBlck(i)+contentCornerStyle(i)" :style="'background-color:'+postBg[i]">

     <!-- Top banner ad container for reviews 2+ -->
     <div v-if="!review['main'][0].IDnum && review['main'][0].no_cost !=1 && i>0" :id="'review-top-banner-'+review['main'][0].ID" class="review-top-banner">
       <!-- Fallback banner - shown when Google ads fail -->
       <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
         <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
       </a>
       <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile">
         <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
       </a>
     </div>


        <div v-if="i<1" class="category-menu">
          <a href="https://www.reviewstream.com" title="ReviewStream.com - consumer reviews"><span class="category-menu-website">ReviewStream.com</span></a>
          <span class="category-menu-raquo">&raquo;</span>
          <a :href="'../reviews/?cat='+review['main'][0].post_category" :title="'Reviews on '+review['category_description']"><span class="category-menu-category">{{review['category_description']}}</span></a>
        </div>        
      
 
        <div :id="'content-title-'+review['main'][0].ID">

            <div v-if="i>0" class="review-title" :id="'title-'+review['main'][0].ID">
                {{review['main'][0].post_title}}
            </div>


            <div v-if="review['main'][0].location" class="location-address">
                {{review['main'][0].location}}
            </div>
        </div>

        <div v-html="review['main'][0].videoCode" v-if="review['main'][0].videoCode" class="video-trailer"></div>   
  

        <div v-if="(i==0 && parseInt(commentPageNum(i)) == 0) || i>0">
      

          <div class="summary-blck" :id="'summary-blck-'+review['main'][0].ID">
              <div v-if="review['main'][0].summary1" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-1'">
              <div id="summary-1-txt">{{review['main'][0].summary1}}</div>
              <div class="summary-btns">
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 1, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 1, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
              </div>  

                  <!---- dynamically add comment form on summary Reply button click --->
                  <div v-if="showSummaryCommentsForm(review['main'][0].ID, 1, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                      <SummaryCommentForm :post_id="review['main'][0].ID" :summary="1"/>
                      <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',1,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
                      
                      <!-- Fallback banner immediately below submit button -->
                      <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                          <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
                        </a>
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
                          <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                        </a>
                      </div>
                  </div>
    
                  <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-1')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-1',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>


              </div>



            
              <div v-if="review['main'][0].summary2" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-2'">
              <div id="summary-2-txt">{{review['main'][0].summary2}}</div>
              <div class="summary-btns">
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 2, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 2, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
              </div> 
                  <!---- dynamically add comment form on summary Reply button click --->
                  <div v-if="showSummaryCommentsForm(review['main'][0].ID, 2, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                      <SummaryCommentForm :post_id="review['main'][0].ID" :summary="2"/>
                      <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',2,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
                      
                      <!-- Fallback banner immediately below submit button -->
                      <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                          <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
                        </a>
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
                          <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                        </a>
                      </div>
                  </div>
                  <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-2')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-2',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>

              </div>

              <!-- Mobile top banner for first review -->
              <div v-if="isMobile() && !review['main'][0].IDnum && review['main'][0].no_cost !=1 && i==0" :id="'review-top-banner-'+review['main'][0].ID" class="review-top-banner top-banner-mobile">
                <!-- Fallback banner - shown when Google ads fail -->
                <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile">
                  <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                </a>
              </div>

              <div v-if="review['main'][0].summary3" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-3'">
              <div id="summary-3-txt">{{review['main'][0].summary3}}</div> 
              <div class="summary-btns">
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 3, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 3, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
              </div>  
                  <!---- dynamically add comment form on summary Reply button click --->
                  <div v-if="showSummaryCommentsForm(review['main'][0].ID, 3, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                      <SummaryCommentForm :post_id="review['main'][0].ID" :summary="3"/>
                      <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',3,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
                      
                      <!-- Fallback banner immediately below submit button -->
                      <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                          <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
                        </a>
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
                          <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                        </a>
                      </div>
                  </div>
                  <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-3')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-3',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>

              </div>
              <div v-if="review['main'][0].summary4" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-4'">
              <div id="summary-4-txt">{{review['main'][0].summary4}}</div> 
              <div class="summary-btns">
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 4, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 4, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
              </div>  
                  <!---- dynamically add comment form on summary Reply button click --->
                  <div v-if="showSummaryCommentsForm(review['main'][0].ID, 4, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                      <SummaryCommentForm :post_id="review['main'][0].ID" :summary="4"/>
                      <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',4,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
                      
                      <!-- Fallback banner immediately below submit button -->
                      <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                          <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
                        </a>
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
                          <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                        </a>
                      </div>
                  </div>
                  <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-4')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-4',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>
          
              </div>
              <div v-if="review['main'][0].summary5" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-5'">
              <div id="summary-5-txt">{{review['main'][0].summary5}}</div> 
              <div class="summary-btns">
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 5, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
                <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 5, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
              </div>  
                  <!---- dynamically add comment form on summary Reply button click --->
                  <div v-if="showSummaryCommentsForm(review['main'][0].ID, 5, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                      <SummaryCommentForm :post_id="review['main'][0].ID" :summary="5"/>
                      <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',5,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
                      
                      <!-- Fallback banner immediately below submit button -->
                      <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                          <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
                        </a>
                        <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
                          <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
                        </a>
                      </div>
                  </div>
                  <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-5')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-5',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>

              </div>
          </div>

          <!-- Desktop top banner for first review -->
          <div v-if="!isMobile() && !review['main'][0].IDnum && review['main'][0].no_cost !=1 && i==0" :id="'review-top-banner-'+review['main'][0].ID" class="review-top-banner">
            <!-- Fallback banner - shown when Google ads fail -->
            <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
              <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
            </a>
          </div>

          <div :id="'content-txt-'+review['main'][0].ID" class="content-txt">

              <div v-if="review['main'][0].main_pic && review['main'][0].submType == 0" class="blck-main-pic">
                <picture>
                  <source :srcset="'../images_items_webp/'+imageWebpFileName(review['main'][0].main_pic)" type="image/webp">

                  <source :srcset="'../images_items/'+review['main'][0].main_pic" type="image/jpeg"> 

                  <img :width="review['main'][0].picwidth" :height="review['main'][0].picheight" :src="'../images_items/'+review['main'][0].main_pic" :alt="'Personal review of '+review['main'][0].post_title" :title="'Personal review of '+review['main'][0].post_title" loading="lazy"/>
                </picture>
              </div>

              <div v-html="review['main'][0].post_content"  class="review-content" :id="'review-'+review['main'][0].ID"></div>
          </div>        
          <div class="review-credentials">
                  <div class="author-name" v-if="review['main'][0].nick">by @{{review['main'][0].nick}}</div>
                  <div class="author-name" v-else>by @anonymous</div>
            <div class="author-blck">
              <div class="byauthor">
                  <div v-if="review['main'][0].photo_url" class="author-pic">
                    <img :src="'../authors/images/'+review['main'][0].photo_url" :title="'Review author: '+review['main'][0].nick" :alt="'Review author: '+review['main'][0].nick" loading="lazy"/>
                  </div>
                  <div v-else class="opacity-01">
        
                          <picture>
                              <source srcset="./assets/icons/ghost.webp" type="image/webp">
                              <source srcset="./assets/icons/ghost.jpg" type="image/jpeg"> 
                              <img width="200" height="120" src="./assets/icons/ghost.jpg" alt="anonymous author" title="anonymous author" loading="lazy"/>
                          </picture>




                  </div>  
                  <div class="trust-block">
                      <TrustChart :trust_data="Math.round(review['main'][0].TR)" />

                  </div>
              </div> 
            </div>
      


              <div class="voting-blck">
                  <div class="like-blck" :id="'like-review-'+review['main'][0].ID" @click="likeSubmit('1',review['main'][0].ID,review['review_voting_url'][0])">
                    <img class="like-img" alt="LIKE" title="LIKE review" src="./assets/icons/likes/like-review.png" loading="lazy"/>
                    <div class="like-thanks" :id="'like-thanks-'+review['main'][0].ID">Thank you :)</div>
                  </div>
                  <div class="dislike-blck" :id="'dislike-review-'+review['main'][0].ID" @click="likeSubmit('2',review['main'][0].ID,review['review_voting_url'][1])">
                    <img class="dislike-img" alt="DISLIKE" title="DISLIKE review" src="./assets/icons/likes/dislike-review.png" loading="lazy"/>
                    <div class="dislike-thanks" :id="'dislike-thanks-'+review['main'][0].ID">Thank you :)</div>
                  </div>
                  
              </div>  
            </div>
        </div>


        <!---QUESTIONS AND ANSWERES-->
        <div class="comments-blck-title" :id="'comments-blck-'+review['main'][0].ID"><img class="chat-icon" src="./assets/icons/chat-icon.png?v=1" alt="Questions, Answers, Comments"/>Questions, Answers, Comments</div>
   
  
      
     <div v-for="(commentsCluster,clusterKey) in review['comments']" :key="clusterKey" class="cluster-wrapper">
        <div class="cluster-vote-wrapper">
           <div v-for="(comment,ii) in commentsCluster" :key="ii" class="commentsBlck" :id="'commentBlck-'+comment.relations">
            

            <a class="aname" :name="comment.relations"></a>
            <div v-if="comment.relations" :class="isClusterStart(comment.relations)" :id="'commentsClusterBlck-'+comment.relations">

                <div v-html="commentBy(comment.comment_by, comment.comment_author)" class="comment-author-blck"></div>  
                <div v-html="postComment(comment.comment_content)"></div>


             <!-- Comment banner ad container -->
             <div v-if="i<2 && commentBannerToShowAll.indexOf(comment.relations)>-1" class="inner-banner comment-banner" :id="'comment-banner-'+comment.relations">
               <!-- Fallback banner - shown when Google ads fail -->
               <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
                 <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
               </a>
               <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile">
                 <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
               </a>
             </div>

               <div class="comment-btns">
                  <div class="comments-btns-reply">
                    <button class="comment-reply-btn" @click="addReplyCommentForm(comment.relations,replyCommentFormShown)" :id="'reply-btn-'+comment.relations" :data-realtions="comment.relations">Reply</button>
                  </div>
                  <div class="comment-btns-social">
                    <div class="comment-btns-social-twitter">
                     <a target="_blank" :href="'https://twitter.com/intent/tweet?url=https%3A%2F%2Freviewstream.com%2Freviews%2F%3Fp%3D'+review['main'][0].ID+'%23'+comment.relations">


                       <picture>
                          <source srcset="./assets/icons/twitter_icon.webp" type="image/webp">
                          <source srcset="./assets/icons/twitter_icon.png" type="image/jpeg"> 
                          <img width="40" height="40" src="./assets/icons/twitter_icon.png" alt="Twitter share" title="Twitter share" loading="lazy"/>
                       </picture>


                     </a>
                   </div>
                   <div class="comment-btns-social-facebook">
                     <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Freviewstream.com%2Freviews%2F%3Fp%3D'+review['main'][0].ID+'%23'+comment.relations">
                      <picture>
                          <source srcset="./assets/icons/facebook_icon.webp" type="image/webp">
                          <source srcset="./assets/icons/facebook_icon.png" type="image/jpeg"> 
                          <img width="40" height="40" src="./assets/icons/facebook_icon.png" alt="Facebook share" title="Facebook share" loading="lazy"/>
                       </picture>
                    
                     </a>
                   </div>
                </div>

             </div> 


             <!--- show newly added replies to other comments --->
              <div v-for="(newcomment,iii) in addedComments" :key="iii" class="commentsBlck">
               <div v-if="review['main'][0].ID == addedComments[iii].post_id && comment.relations == addedComments[iii].relation_id" class="commentsClusterBlck">
                 <div v-html="commentBy('', addedComments[iii].author)" class="comment-author-blck"></div>
                 <div v-html="addedComments[iii].newcomment"></div>
                 <div class="greeting-message" v-html="addedComments[iii].greetingMsg"></div>
               </div>   
              </div>

  
               <!---- dynamically add comment form on Reply button click --->
               <div v-if="replyCommentFormShown.indexOf(comment.relations)>-1" :id="'addReplyCommentBlck-'+comment.relations" class="relative">
                  <ReplyCommentForm :relation="comment.relations" :post_id="review['main'][0].ID" :addedComments="addedComments" :submitCommentParent="submitComment" :count="i"/>
               </div>

 
            </div>   

             <div v-if="ii == commentsCluster.length - 1" class="cluster-vote-blck">
                <div class="cluster-vote-title">helpful ?</div>
                <div class="cluster-vote-arrow" v-on:click="clusterHelpfulVote(comment.relations, '2')">NO</div>
                <div class="cluster-vote-arrow" v-on:click="clusterHelpfulVote(comment.relations, '1')">YES</div>
                <div class="cluster-vote-result" :id="'cluster-vote-'+comment.relations">{{comment.claster_score}}</div>
             </div>


         </div>


        </div>



      </div>
          <!--- show newly added comments to the whole review --->
           <div v-for="(newcomment,c) in addedComments" :key="c" class="commentsBlck">
            <div v-if="review['main'][0].ID == addedComments[c].post_id && addedComments[c].relation_id == ''" class="commentsClusterBlck">
              <div v-html="commentBy('', addedComments[c].author)" class="comment-author-blck"></div>
              <div v-html="addedComments[c].newcomment"></div>
         
         <!-- Fallback banner immediately below submit button -->
         <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
           <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
             <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
           </a>
           <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
             <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
           </a>
         </div>
              <div class="greeting-message" v-html="addedComments[c].greetingMsg"></div>  
            </div> 
           </div>


        <div v-if="review['main'][0].total_clusters > commentClusterPerPage" class="more-comments-blck">
             <MoreCommentsButtons 
                   :post_id="review['main'][0].ID" 
                   :total_comments="review['main'][0].total_comments" 
                   :total_clusters="review['main'][0].total_clusters" 
                   :cluster_perpage="commentClusterPerPage" 
                   :pageNum="commentPageNum(i)"/> 
        </div>


        <div>
         <input name="comment-author-input" class="comment-details-input comment-blck-top" :id="'comment-author-input-'+review['main'][0].ID" placeholder="Your name (required)" />
         <input name="comment-author-email-input" class="comment-details-input" :id="'comment-author-email-input-'+review['main'][0].ID" placeholder="Your email (required for the review author)"/>
         <textarea name="comment-input" class="comment-input" :id="'comment-input-'+review['main'][0].ID" placeholder="Share your thoughts. Ask. Your opinion is valuable."></textarea>  
         <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'')">submit comment</button>

         <CommentAdSense v-if="i===0"/>

         <!-- Fallback banner immediately below submit button -->
         <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
           <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
             <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
           </a>
           <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
             <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
           </a>
         </div>
        </div>



 
      </div>
      <div v-if="relatedContentRightColumn && relatedContentRightColumn.length > 0">
        <div class="related-blck-title" :id="'related-blck-'+review['main'][0].ID"><img class="related-icon" src="./assets/icons/related.png?v=1" alt="related reviews icon" title="related reviews icon" loading="lazy"/>Related reviews</div>
        <div class="bottom-related-blck">
          <div v-for="related in relatedContentRightColumn.slice(0, 5)"  v-bind:key="related">
            <a :href="related.related_link" :title="related.related_title" :alt="related.related_title" class="bottom-related-link">
            <div class="bottom-rel-title">
              {{ related.related_title }}
            </div>
            </a> 
          </div> 
        </div>
      </div>

        <!----<div class="content-blck-bottom" ></div>--->


       
      </div>
    





   </div>





   <!-----<div class="related-column">
       <ul class="related-blck-permanent">
        <li v-for="related in relatedContentRightColumn"  v-bind:key="related">
          <a :href="related.related_link" :title="related.related_title">
          <div class="right-rel-title">
            {{ related.related_title }}
          </div>

          <div v-if="related.related_pic">
             <picture>
               <source :srcset="'../images_items_webp/'+imageWebpFileName(related.related_pic)" type="image/webp">
               <source :srcset="'../images_items/'+related.related_pic" type="image/jpeg"> 
               <img :src="'../images_items/'+related.related_pic" :width="(related.pic_width*0.6)" :height="(related.pic_height*0.6)" :alt="related.related_title" :title="related.related_title" loading="lazy"/>
             </picture>
          </div>

          <div class="right-summary-blck">
           <div v-if="related.summary1" class="right-summary">&bull; {{ related.summary1 }}</div>
           <div v-if="related.summary2" class="right-summary">&bull; {{ related.summary2 }}</div>
           <div v-if="related.summary3" class="right-summary">&bull; {{ related.summary3 }}</div>
           <div v-if="related.summary4" class="right-summary">&bull; {{ related.summary4 }}</div>
           <div v-if="related.summary5" class="right-summary">&bull; {{ related.summary5 }}</div>
           <div class="right-summary-out-icon"><vue-feather type="arrow-right-circle" size="2.5rem" stroke-width="1"></vue-feather></div>
           </div>
         </a>
        </li>
      </ul>
   </div>--->
   

  </div>

  <!----
     <transition name="slide">
      <div v-if="showBanner" class="cookie-warning">
        <p>ReviewStream uses browser cookies to give you the best possible experience. To make ReviewStream work, we log user data and share it with processors. To use ReviewStream, you must agree to our <a href="/privacy.php" target="_blank" title="Privacy policy">privacy policy</a>.
        </p>
        <button class="cookie-warning-btn" @click="okBannerClicked">I agree</button>
       
      </div>
    </transition>
  --->
 


</template>

<script>
  import MainHeader from './components/MainHeader.vue'
  import SearchBlock from './components/SearchBlock.vue'
  import TrustChart from './components/TrustChart.vue'
  import ReplyCommentForm from './components/ReplyCommentForm.vue'
  import SummaryCommentForm from './components/SummaryCommentForm.vue'
  import MoreCommentsButtons from './components/MoreCommentsButtons.vue'
  import TopAdSense from './components/TopAdSense.vue'
  import CommentAdSense from './components/CommentAdSense.vue'
  //import useCookies from './components/useCookies.vue'
  import {fade,unfade} from '@/assets/js/global.js'
  import {defineAsyncComponent, inject, defineComponent} from 'vue'
  import { ref, onBeforeMount, onUnmounted, onMounted, nextTick } from 'vue'
  import {unescape} from 'html-escaper'
  import { gsap } from "gsap"
  import { ScrollTrigger } from "gsap/ScrollTrigger"
  import { useGoogleAds } from '@/composables/useGoogleAds.js'
  gsap.registerPlugin(ScrollTrigger)

  const VueFeather = defineAsyncComponent(() =>
     import('vue-feather')
  )


 

  
  //function shuffleBackgroundColor(bgcolors){
  //    let newbgcolors = [...bgcolors];
  //    const getRandomValue = (i, N) => Math.floor(Math.random() * (N - i) + i);
  //    newbgcolors.forEach( (elem, i, arr, j = getRandomValue(i, arr.length)) => [arr[i], arr[j]] = [arr[j], arr[i]] );
  //    return newbgcolors;
  //}




  export default defineComponent({
    components: {
      VueFeather,
      SummaryCommentForm,
      ReplyCommentForm,
      MainHeader,
      SearchBlock,
      TrustChart,
      MoreCommentsButtons,
      TopAdSense,
      CommentAdSense,
    },
    data: function() {
      return {
        //showReplyCommentForm: false,
        replyCommentFormShown: [],
        addedComments: [],
        summaryCommentFormShown: [],
        summaryCommentGreetingAll: [
          'Great input.',
          'Helpful as usual.',
          'You are the best.',
          'You will be rewarded.',
          'Pleasure to assist you.'
        ],
        summaryCommentGreetingToShow: []
        
        
 
      }
    },
    setup() {


      const gtag = inject('gtag');
      //const { showBanner, okClicked } = useCookies(gtag);
      const okBannerClicked = () => okClicked();

           

      let urlObject = new URL(document.location.href)
      let params = urlObject.searchParams
      let reviewId = params.get("p")
      let commentPageNum = (i) =>{
         if(!params.get("n") || i>0){
          return "0"
         }
         else{
          return params.get("n")
         }
      }   
      const firstReviewId = reviewId

      let commentClusterPerPage = 100
      
 
      let firstReviewTitle = ref([])
      let content = ref([])
      let content_shown = ref([])
      let contentList = ref([])
      
      let relatedContent = ref([])
      let relatedContentRightColumn = ref([])
      let relatedShown = 0
      let mainCategory = 0
      let categoryShown = 0
      let isCategory = false
      let totalShown = 1
      let doFetch = true
      let summaryCommentGreetingShown = ref([])
      
      let promiseFetch

      let postBg = ref([])

      //let contentBackgroundColor = ['#fbe3e8','#fceed1','#e5eaf5','#DCC7AA','#e4decd','#f7f7f7','#e1e8f0','#f1f0ee','#CAE4DB','#DFDCE3','#dfd8c8']
      let lastBgColor
      
      let isMobile = () => {
        if(window.innerWidth >420){
            return false
        }
        else{
          return true
        }
       }

      // Google Ads state variables
      let noAdsPage = inject('noAdsPage')

      // Initialize Google Ads composable
      const {
        gptInitialized,
        gptLoadFailed,
        gptLoadTimeout,
        adBlockerDetected,
        adLoadErrors,
        detectAdBlocker,
        initializeGPT,
        loadAdsForReview,
        loadCommentAdsOnScroll
      } = useGoogleAds()

      // Track comment banner placements for scroll-based loading
      let commentBannerToShowAll = ref([])

     let handleScroll = () => {

      // Load comment banner ads when they enter viewport
      loadCommentAdsOnScroll(commentBannerToShowAll.value)

      // Check if user has scrolled to near the bottom of the page
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 1000) {

       if(!content_shown.value.includes(reviewId) && totalShown>1 && doFetch){
          fetchContent(reviewId,mainCategory,commentClusterPerPage)
          doFetch = false
         } 
         else{
             //console.log('stopped '+reviewId)
         }
        }
      }



      const fetchFirstTitle = async (r) =>{
          let firstTitleResponse
          try {
            if(r>0){
              //firstTitleResponse = await fetch('https://www.reviewstream.com/reviews/api/first-review-title.php?do='+r)
              
              firstTitleResponse = await fetch('../reviews/api/first-review-title.php?do='+r)
              
              const parsedFirstTitleResponse = await firstTitleResponse.json()
              firstReviewTitle.value = parsedFirstTitleResponse
            }
          } 
          catch(err) {
          //console.log(err) // state-of-the-art-error-handling
          }
      }





      const fetchContent = async (r,c,commentClusterPerPage,commentsPageNum) => {

        //console.log('fetched')
        
         
        try {
              //console.log(relatedShown+'...'+JSON.stringify(relatedContent.value))
              //console.log('r '+r)  
              let mainResponse
              if(r != null && r > 0){
                  //!!!!!!!!!!!!PAY ATTENTION THIS TEST API
                  //mainResponse = await fetch('https://www.reviewstream.com/reviews/api/review_test.php?do='+r+'&total='+totalShown+'&comments='+commentClusterPerPage+'&n='+commentsPageNum)
                  
                  // THIS ONE IS REAL
                  mainResponse = await fetch('../reviews/api/review.php?do='+r+'&total='+totalShown+'&comments='+commentClusterPerPage+'&n='+commentsPageNum)
                  
                  //console.log('GET REVIEW 1 : ../reviews/api/review.php?do='+r+'&total='+totalShown+'&comments='+commentClusterPerPage+'&n='+commentsPageNum)
              }
              else{
                  //!!!!!!!!!!!PAY ATTENTION THIS TEST API
                  //mainResponse = await fetch('https://www.reviewstream.com/reviews/api/review_test.php?cat='+c+'&show='+categoryShown+'&total='+totalShown)
                  
                  // THIS ONE IS REAL
                  mainResponse = await fetch('../reviews/api/review.php?cat='+c+'&show='+categoryShown+'&total='+totalShown+'&comments='+commentClusterPerPage+'&n='+commentsPageNum)


                  //console.log('GET REVIEW 2 : ../reviews/api/review.php?cat='+c+'&show='+categoryShown+'&total='+totalShown+'&comments='+commentClusterPerPage+'&n='+commentsPageNum)


                  isCategory = true

                  //console.log('../reviews/api/review.php?cat='+c+'&show='+categoryShown+'&total='+totalShown+'&comments='+commentClusterPerPage+'&n='+commentsPageNum)
                  //console.log('mainResponse '+ JSON.stringify(mainResponse))
              }
              const parsedResponse = await mainResponse.json()

              //console.log('parsedResponse '+JSON.stringify(parsedResponse))


//FOR TEST
//parsedResponse = {"main":[{"ID":"9344","post_author":"1","post_date":"2006-09-20 05:42:56","post_date_gmt":"2006-09-20 12:42:56","post_content":"USB drives are wonderful things.","words_count":"344","related_count":"15","post_title":"SanDisk Cruzer USB Drive 512 Mb","duplicate_title":"1","post_category":"33","post_excerpt":"","post_status":"publish","comment_status":"open","ping_status":"closed","post_password":"","post_name":"sandisk-cruzer-usb-drive-512-mb","to_ping":"","pinged":"","post_modified":"2006-09-20 05:36:04","post_modified_gmt":"2006-09-20 12:36:04","post_content_filtered":"","post_parent":"0","guid":"http:\/\/www.reviewstream.com\/reviews\/?p=ID","menu_order":"0","account":"","nick":"","paid":"","processed":"","votes":"3","submType":"0","video":"0","overall":"4.0","meta_description":"USB drives are wonderful things. SanDisk is one of the biggest names in USB drives, and I must say I am very happy with mine. I purchased it on sale","IDnum":null,"rates_total":"1","videoCode":null,"id_photo":null,"photo_url":null,"id_trust":null,"TR":null,"followers_total":null,"related_ID":"0","main_pic":"yjsmr6ztz.jpeg","picwidth":"300","picheight":"262","summary1":"SanDisk is one of the biggest names in USB drives, and I must say I am very happy with mine","summary2":"I purchased it on sale and got the 512 Mb version for $17.99 (after rebate), not a bad price at all","summary3":"In retrospect, however, I wonder if I should have gotten a larger model","summary4":"","summary5":"","total_comments":"0","no_cost":"0","total_clusters":"1","location":"","ads_layout":3}],"total_incat":"1501","category_description":"Hardware reviews","comments":[[{"comment_ID":"274563","comment_post_ID":"9344","post_author_email":"","comment_author":"Michel D sir BAKOBOM FOUMENA","comment_author_email":"mikedidicom@gmail.com","comment_author_url":"","comment_author_IP":"172.71.30.36","comment_date":"2023-12-21 21:05:24","comment_date_gmt":"2023-12-22 04:05:24","comment_content":"SanDisk is one of the biggest names in USB drives, and I must say I am very happy with mine<\/span><br>The SanDisk Cruzer USB Drive 512 Mb is a flash drive that provides a practical solution for storing and transferring files. Its retractable USB connector shields it from dust and damage, while its rubber casing renders it splash-resistant. The SanDisk SecureAccess software that accompanies it enables users to encrypt and password-protect their files.\n\nThe SanDisk Cruzer USB Drive 512 Mb boasts several strengths, including its small and lightweight design, making it effortless to carry around. Despite its size, it has a large storage capacity, capable of holding hundreds of documents, photos, or songs. It also has a fast data transfer rate, particularly when used with a USB 2.0 port on a computer. The metallic look and white spot for writing one's name and contact information give it a sleek and straightforward design. Additionally, it is relatively inexpensive compared to other flash drives with similar features.\n\nHowever, the SanDisk Cruzer USB Drive 512 Mb has some weaknesses. Its write speed is slow, making it take longer to copy files to the drive than to read them from it. It has a USB 2.0 connectivity, which is outdated and may not be compatible with newer devices that use USB 3.0 or higher. Flash drives tend to degrade over time, and their ability to store data diminishes, making their lifespan limited. The cap is flimsy and may fall off or get lost easily. Furthermore, some online reviews criticize its poor customer service, citing defective products, delayed deliveries, and unresponsive support.\n\nConsidering these strengths and weaknesses, I would rate the SanDisk Cruzer USB Drive 512 Mb a 3 out of 5. It is a decent product that performs its function well, but it is not particularly impressive or innovative. While it has some useful features, it also has drawbacks that may impact its performance and durability. It is an excellent choice for casual users who require a simple and affordable flash drive, but not for professional or demanding users who need a faster and more reliable flash drive.","comment_karma":"0","comment_approved":"1","comment_agent":"Mozilla\/5.0 (Linux; Android 10; K) AppleWebKit\/537.36 (KHTML, like Gecko) Chrome\/120.0.0.0 Mobile Safari\/537.36","comment_type":"","comment_parent":"0","user_id":"0","comment_by":"","relations":"9344-1001","claster_id":"9344-1001","Hlight":"0","replied":"0","to_replace":"","dont_show":"0","review_category":"33","claster_score":"0","show_onaction":"0","appIdent":"","notify":"0"}]],"comment_banner_place":["9344-1001"],"related_reviews":[{"related_id":"76526","related_title":"Sandisk USB micro Cruzer All sizes","related_link":"?p=76526","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"So I can take my computer where ever I go","summary2":"","summary3":"","summary4":"","summary5":""},{"related_id":"162578","related_title":"SanDisk Cruzer Fit CZ33 32GB USB Flash Drive","related_link":"?p=162578","related_pic":"XXLBSWLoI.jpg","pic_height":"300","pic_width":"300","summary1":"After seeing a couple that were so and so when comparing their price tag with their capabilities, I found the SanDisk Cruzer Fit CZ33 32GB USB Flash Drive","summary2":"It looked like what I wanted to buy so I paid the equivalent of $30 for it","summary3":"This was actually one of the main reasons why I bought it in the first place","summary4":"I highly recommend getting this little flash drive because it\u00e2\u20ac\u2122s just magnificent","summary5":""},{"related_id":"61508","related_title":"SanDisk Cruzer Crossfire USB Flash Drive","related_link":"?p=61508","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"Apart from this, a great product would definitely recommend","summary2":"","summary3":"","summary4":"","summary5":""},{"related_id":"66655","related_title":"Sandisk Cruzer Micro USB Flash Drive","related_link":"?p=66655","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"These drives come with a retractable USB port, so this eliminates the problem of losing caps","summary2":"","summary3":"","summary4":"","summary5":""},{"related_id":"33301","related_title":"SanDisk Cruzer micro 1 GB Flash Drive","related_link":"?p=33301","related_pic":"hOtIzj47V.jpg","pic_height":"300","pic_width":"300","summary1":"A handy tool for students, professionals, and the like, Cruzer micro is the perfect option for those needing a convenient way to store a few files, or to transfer them from computer to computer","summary2":"It is perfectly sized and streamlined, meaning it can fit around pre-existing USB wires or in weirdly angled USB ports (a problem I have had with past flash drives)","summary3":"I believe it only cost me about $7 dollars (with rebates) for the Cruzer micro, and I'm so glad I bought it","summary4":"","summary5":""},{"related_id":"15409","related_title":"SanDisk Cruizer USB Flash Drive","related_link":"?p=15409","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"And Priced at $35 for a 2GB drive, I would highly suggest this device to anyone who works from multiple computers on a routine basis","summary2":"","summary3":"","summary4":"","summary5":""},{"related_id":"52152","related_title":"Cruzer Micro 8GB","related_link":"?p=52152","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"Really effective, simple to use and interesting product","summary2":"","summary3":"","summary4":"","summary5":""},{"related_id":"124474","related_title":"SanDisk 2G SD Memory Card","related_link":"?p=124474","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"Dislikes- The only thing that I don't like about the SanDisk SD memory card is that it is so small it would be easy to lose","summary2":"I have to keep it in specific places or I would definitely lose it","summary3":"It is a good way to back up some of your work from your computer, although you wouldn't be able to keep a mass amount of files on the disk, it has stored a large quantity of my Microsoft Word files with no problem at all","summary4":"","summary5":""},{"related_id":"8303","related_title":"USB stick Cruzer mini 256mb","related_link":"?p=8303","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"This is one product that I wouldn't recommend because it's so BAD","summary2":"","summary3":"","summary4":"","summary5":""},{"related_id":"3070","related_title":"Sandisk 1GB Compact Flash Card","related_link":"?p=3070","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"I recently purchased this 1 GB flash card by sandisk and have been very impressed with it","summary2":"","summary3":"","summary4":"","summary5":""},{"related_id":"96575","related_title":"SanDisk 64MB CompactFlash memory card","related_link":"?p=96575","related_pic":"IBEzZfrJR.jpeg","pic_height":"300","pic_width":"300","summary1":"I have never had a problem with getting a camera to recognise this card, which is as it should be","summary2":"","summary3":"","summary4":"","summary5":""},{"related_id":"100350","related_title":"SanDisk micro flash memory card","related_link":"?p=100350","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"However, now after using it for the last six months, I can say that they are leading player only and only because they provide the best available quality in the market","summary2":"Seeing its impeccable performance for the last six months, I am unable to deduct a single rating point and in the same breadth I would like to recommend it to anyone who is planning to have a micro flash memory card","summary3":"","summary4":"","summary5":""},{"related_id":"128985","related_title":"SanDisk 4 GB Micro SD High Capacity Memory Card","related_link":"?p=128985","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"I love having the extra memory that the Micro Memory Card allows me to have","summary2":"","summary3":"","summary4":"","summary5":""},{"related_id":"2821","related_title":"Apacer CP80 R-RW Drive","related_link":"?p=2821","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"You can also easily connect this drive to your laptop computer, which can save you the cost of buying a whole new laptop because you want to be able to make CDs","summary2":"","summary3":"","summary4":"","summary5":""},{"related_id":"68454","related_title":"Kingston 2GB flash drive","related_link":"?p=68454","related_pic":null,"pic_height":null,"pic_width":null,"summary1":"I bought this branded Kingston flash drive at cheaper price and I was able to store up a lot of files because it has 2 GB space","summary2":"I see to it to check this flash drive before I insert it on my laptop If every I used it from office, and I have no problem because the flash drive is clean","summary3":"","summary4":"","summary5":""}],"prev_next":{"prev_title":"Mindswap by Robert Sheckley","prev_id":9343,"next_title":"Dell Dimension Desktop 5150","next_id":9345},"toughts_box":"w5b4r4h4e456g4334464s2","review_voting_url":["w5b4r4h4e456g4334464s2u3h594e4y51623a454l4p4m5m4r5","w5b4r4h4e456g4334464s2u3h594e4y51623g4f4t484o564r5i4m5p4c4"]}






              if(JSON.stringify(parsedResponse) != 1){
                      content.value = parsedResponse
                  
                      if(mainCategory == 0){
                          mainCategory = content.value.main[0].post_category
                          //console.log('mainCategory '+mainCategory)
                      }

                      
                      
                      if(content.value.main[0].ID>0 && !content_shown.value.includes(content.value.main[0].ID)){

                    
                            contentList.value = [...contentList.value,content.value]

                            //console.log('contentList ' + contentList)

                            //post background color routine
                            //const getRandomValue = (i, N) => Math.floor(Math.random() * (N - i) + i);
                            //contentBackgroundColor.forEach( (elem, i, arr, j = getRandomValue(i, arr.length)) => [arr[i], arr[j]] = [arr[j], arr[i]] );
                            //lastBgColor = contentBackgroundColor[contentBackgroundColor.length-1]
                            //if(lastBgColor != contentBackgroundColor[0]){
                            //    postBg.value = [...postBg.value,...contentBackgroundColor]
                            //}   
                            //end background color routine

                            content_shown.value.push(content.value.main[0].ID)

                            doFetch = true


                            totalShown++

                            // Track comment banner placements for this review
                            if (content.value.comment_banner_place && content.value.comment_banner_place.length > 0) {
                              content.value.comment_banner_place.forEach(commentId => {
                                if (!commentBannerToShowAll.value.includes(commentId)) {
                                  commentBannerToShowAll.value.push(commentId)
                                }
                              })
                            }

                            // Load ads for this review after DOM is updated
                            nextTick(async () => {
                              const reviewIndex = contentList.value.length - 1
                              const { loadAdsForReview, gptInitialized, showAllFallbackBanners } = useGoogleAds()

                              /*
                              // If GPT didn't initialize, show all fallback banners immediately
                              if (!gptInitialized.value) {
                                showAllFallbackBanners()
                              }
                              */

                              await loadAdsForReview(content.value, reviewIndex, totalShown)
                            })

                          // if(isCategory){categoryShown++}

                            //console.log('TOTAL '+totalShown+'...cat '+categoryShown)


                      }






                      if(isCategory){categoryShown++}

               }
             
             
                      //console.log('tut '+relatedContent.value.length);  
                      if(relatedContent.value.length==0 || relatedContent.value.length==relatedShown){

                        
                                relatedContent.value = Object.values(content.value.related_reviews).filter(function(objFromA) {
                                        return !content_shown.value.find(function(objFromB) {
                                        return objFromA.related_id === objFromB
                                        })
                                        })

                                relatedContentRightColumn.value = [...relatedContentRightColumn.value,...relatedContent.value]



                                if(relatedContent.value.length == 0 && mainCategory > 0){
                                  reviewId = 0
                                  console.log('CATEGORY STARTED '+mainCategory)

                                  fetchContent(reviewId, mainCategory,commentClusterPerPage)




                                }
                                else{
                                  relatedShown=0
                                    //console.log(relatedShown+'--- '+JSON.stringify(relatedContent.value))

                                  reviewId = relatedContent.value[0].related_id
                                  //console.log('*** '+reviewId)
                                }




                      }
                      else{
                      reviewId = relatedContent.value[relatedShown].related_id
                      //console.log('tut '+relatedShown+'...'+reviewId)
                      }

             
                      relatedShown++




  
        } 
        catch(err) {
          console.log("Error message:", err.message);
          console.log("Stack trace:", err.stack);
        }
        

      }

      onBeforeMount(() => {
        
        fetchFirstTitle(reviewId)

        //console.log('first title fetched')

      
        return new Promise(function(resolve, reject) {

          //console.log('reviewId '+ reviewId)
          //console.log('mainCategory '+ mainCategory)
          //console.log('commentClusterPerPage ' + commentClusterPerPage)
          //console.log('n ' + params.get("n")) 
      
          fetchContent(reviewId,mainCategory,commentClusterPerPage,params.get("n"))
        })
        
      })
      onMounted(() => {

        

      

  
       

       window.addEventListener('scroll', handleScroll)


       // Detect ad blockers early
       if (!noAdsPage) {
         detectAdBlocker()
       }

       // Initialize Google Publisher Tag and load first review ads
       if (!noAdsPage) {
         // Wait for DOM to be fully rendered before loading first review ads
         nextTick(async () => {
           if (contentList.value.length > 0) {
             const { loadFirstReviewAds, gptInitialized, showAllFallbackBanners } = useGoogleAds()

             // Try to load ads
             await loadFirstReviewAds(contentList.value[0])

             // If GPT didn't initialize, show all fallback banners immediately
             if (!gptInitialized.value) {
               console.log('[App] GPT not initialized, showing all fallback banners')
               showAllFallbackBanners()
             }
           }
         })
       }


        //Lessen top menu routine
        ScrollTrigger.refresh();

        const topMenuScrollLessenStart = 'top 0'
        const topMenuScrollLessenEnd = 999999
        //const lineTimeline = gsap.timeline()
        
        ScrollTrigger.create({
            start: topMenuScrollLessenStart,
            end: topMenuScrollLessenEnd,
            toggleClass: {className: 'top-menu-icon-container-scrolled', targets: '.top-menu-icon-container'},
        });
        ScrollTrigger.create({
            start: topMenuScrollLessenStart,
            end: topMenuScrollLessenEnd,
            toggleClass: {className: 'top-menu-scrolled', targets: '.top-menu'},
        });
        ScrollTrigger.create({
            start: topMenuScrollLessenStart,
            end: topMenuScrollLessenEnd,
            toggleClass: {className: 'header-logo-scrolled', targets: '.header-logo'},
        });
        ScrollTrigger.create({
            start: topMenuScrollLessenStart,
            end: topMenuScrollLessenEnd,
            toggleClass: {className: 'header-moto-scrolled', targets: '.header-moto'},
        });
        ScrollTrigger.create({
            start: topMenuScrollLessenStart,
            end: topMenuScrollLessenEnd,
            toggleClass: {className: 'header-left-menu-scrolled', targets: '.header-left-menu'},
        });

        //end top menu lessen

        

 
          
        let OnEvent = (doc) => {
          return {
            on: async (type, selector, callback) => {
                doc.addEventListener(type, (event)=>{
                    if(!event.target.matches(selector)) return;
                    callback.call(event.target, event);
                }, false);
            }
          }
        };


        OnEvent(document).on('click', '.comment-outgoing-link', async function (e) {
         try{
            let commentId = e.target.id.split(':::')[0]
            let linknum = e.target.id.split(':::')[1]
    
            //console.log(commentId+'...'+linknum)

             const getOutgoingLinkUrl = "../reviews/outgoing_link_vue.php"
 
             let outLinkResponse
             let outLinkResponseData
             const outLinkOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ details: commentId, linknum: linknum })
             };
             
             outLinkResponse = await fetch(getOutgoingLinkUrl, outLinkOptions)

             outLinkResponseData = await outLinkResponse.json()
             let outLinkReply = JSON.stringify(outLinkResponseData)
             if(outLinkReply == 1){
                console.log('out link error')
             }
             else{  
               if(JSON.stringify(outLinkResponseData) != 1){         
                 //console.log(outLinkResponseData.link) 
                 //console.log(outLinkResponseData.title) 
 
                let outgoingLinkDisclaimer = '<div class="outgoing-link-disclaimer">Disclaimer: ReviewStream.com is not responsible for the contents of any web page referenced from this server.</div>'
                let showCommentLinkBlck = document.getElementById('commentsClusterBlck-'+commentId)
                let showCommentLinkTxt = '<div class="outgoing-link"><a href="'+outLinkResponseData.link+'" target="_blank">'+outLinkResponseData.title+'</a>'+outgoingLinkDisclaimer+'</div>'
                showCommentLinkBlck.innerHTML +=(showCommentLinkTxt)
               }
              }
           }
           catch(err) {
               console.log(err)
           }
        
     
         });


       
      })
      onUnmounted(() => {
        window.removeEventListener('scroll', handleScroll)
        
      })
      return {
        relatedContent,
        relatedContentRightColumn,
        contentList,
        postBg,
        okBannerClicked,
        isMobile,
        summaryCommentGreetingShown,
        firstReviewTitle,
        commentClusterPerPage,
        commentPageNum,
        reviewId,
        // Google Ads related
        commentBannerToShowAll,
        loadAdsForReview
      }
    },
    methods: {
    //  placeCommentBanner: (i) => {
    //     if(i%3){
    //       return true
    //     }
    //  },
    //  commentBannerCount: (commentBannerShown,commentBannerNum) => {
    //       commentBannerShown.push(commentBannerNum)
    //       commentBannerNum++
    //       console.log('commentBannerShown '+commentBannerShown)
    //       
    //  },
      imageWebpFileName: (filename) => {
        let imageNameBase = filename.split('.')[0]
        return imageNameBase+'.webp'

      },
      commentsCountText: (total) => {
         if(total>1){
           return "comments"
         }
         else{
           return "comment"
         }
      },
      isClusterStart: (relations) => {
        //console.log('relations '+relations)
        if (relations.match(/:/)) {
          return "commentsClusterBlck related-comment"
        }
      
       return "commentsClusterBlck"
      },
      postComment: (txt) => {
          return unescape(txt.replace(/\r?\n|\r/g, '<br>'))
      },
      commentBy: (c,a) => {
        let by
        if(!c){by = a+' says'}
        else if(!a){by = 'quick note by anonymous'}
        else if(c == 'Q'){by = a}
        else if(c == 'AA'){by = '<span class="author-comment-sign">author</span> '+a+' adds'}
        else{by = '<span class="author-comment-sign">author</span> '+a+' replies'}
        return by
      },
      addReplyCommentForm(r,replyCommentFormShown){

           replyCommentFormShown.push(r)

      },
      addSummaryCommentForm(review_id, summary_num, btn_clicked, summaryCommentFormShown){

          //console.log('summary_num '+summary_num)

          //console.log('summaryCommentFormShown   xxx '+summaryCommentFormShown)

           let newSummaryComment = {'review_id': review_id, 'summary_num': summary_num, 'btn_clicked': btn_clicked}

           //console.log('newSummaryComment '+JSON.stringify(newSummaryComment))

           summaryCommentFormShown.push(newSummaryComment)

           //console.log(summaryCommentFormShown)

           


      },
      showSummaryCommentsForm(review_id, summary_num, summaryCommentFormShown){


        //console.log('SHOW summaryCommentFormShown '+JSON.stringify(summaryCommentFormShown))
        //console.log('SHOW length '+summaryCommentFormShown.length)
        //console.log('SHOW review_id '+review_id+'...summary_num '+summary_num)
             
             //if(summaryCommentFormShown.some(summaryCommentFormShown => summaryCommentFormShown['review_id'] === review_id )){
             //  return true;
             //}
             let x = false
             for(let i=0;i<summaryCommentFormShown.length;i++){
               //console.log('SHOW tut.. '+summaryCommentFormShown[i].review_id)
               //console.log('SHOW tut... '+summaryCommentFormShown[i].summary_num)
               if(summaryCommentFormShown[i].review_id === review_id && summaryCommentFormShown[i].summary_num === summary_num){
                 //console.log('SHOW tut 1')
                 x = true;
               }
             }

            //console.log('xxxxx '+x)

          return x

      },
      showSummaryCommentGreeting(summaryCommentGreetingAll){
          if(this.summaryCommentGreetingToShow.length === 0){
            this.summaryCommentGreetingToShow = Array.from(summaryCommentGreetingAll)
          }
          //let's shuffle greeting
          for (let i = this.summaryCommentGreetingToShow.length - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1));
            [this.summaryCommentGreetingToShow[i], this.summaryCommentGreetingToShow[j]] = [this.summaryCommentGreetingToShow[j], this.summaryCommentGreetingToShow[i]];
          }
          //console.log('summaryCommentGreetingToShow '+this.summaryCommentGreetingToShow)

          let greetingToShow = this.summaryCommentGreetingToShow[0]
          //console.log('greetingToShow '+greetingToShow)
          this.summaryCommentGreetingToShow.shift()
          return '<div class="summary-greeting"><div class="summary-greeting-publish">Published.</div><div class="summary-greeting-text">'+greetingToShow+'</div><div class="summary-greeting-thanks">Thank you :)</div></div>' 

      },

      fetchSummaryCommentGreeting(summary_id,summaryCommentGreetingShown){
          return summaryCommentGreetingShown.find(x => x.summary === summary_id).greeting
      },
      ReadMoreClicked: async (event) => {

           let clickedDivPosition = event.target.getBoundingClientRect()
           let clickedDivFromTop = {
              top: clickedDivPosition.top + window.pageYOffset
           };
           let ReadMoreClickedResponse = await fetch('../reviews_vue/statistics/read-more-clicked-vue.php?top='+clickedDivFromTop.top)




      },
      likeSubmit: async (like,review_id,voting_url) => {
      
         //console.log('voting_url '+voting_url)

           if(like == 1){
                  let el = document.getElementById('dislike-review-'+review_id)
                  el.classList.add('collapse-dislike-blck')
            }
            if(like == 2){
                  let el = document.getElementById('like-review-'+review_id)
                  el.classList.add('collapse-like-blck')
            } 
       
        const reviewVoteUrl = "../reviews/votes_process_vue.php"

        try{

        
             let reviewVotePostResponse
             let reviewVotePostResponseData
             const reviewVotingOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ vurl: voting_url })
             };
             
             
             
             reviewVotePostResponse = await fetch(reviewVoteUrl, reviewVotingOptions)

             //console.log('reviewVotePostResponse '+ JSON.stringify(reviewVotePostResponse))

             reviewVotePostResponseData = await reviewVotePostResponse.json()
             
             //console.log('reviewVotePostResponseData '+reviewVotePostResponseData)

             let reviewVoteReply = JSON.stringify(reviewVotePostResponseData)
 
             //console.log('reviewVoteReply '+reviewVoteReply);

             if(reviewVoteReply == 1){
                if(like == 1){            //LIKE
                  let likeThanksSign = document.getElementById('like-thanks-'+review_id);
                  likeThanksSign.style.visibility = 'visible';
                }
                if(like == 2){            //DISLIKE
                  let dislikeThanksSign = document.getElementById('dislike-thanks-'+review_id);
                  dislikeThanksSign.style.visibility = 'visible';
 
                }
             }
             else{              //anything but sucess (when, for ex., both buttons clicked from same IP address)
                window.location.href = "/";
             }


        
          } 
          catch(err) {
            //console.log(err) // state-of-the-art-error-handling
          }
       
 
      },
      firstContentBlck(i){
        if(i==0){
          return " content-blck-first"
        }
        else{
          return ""
        }
      },
      contentCornerStyle(i){
        if(i<2){
          return " content-blck-corner-right"
        }
        else{
          return " content-blck-corner-left"
        }
      },
      searchBlockStyle(i,postBg){
          if(i<3){
            return 'border-right:3px solid '+postBg[i-1]
          }
          else{
            return 'border-left:2px solid #E66D29'
          }
      },
      clusterHelpfulVote: async (cluster, vote) => {

          
          const clusterVoteUrl = "../reviews/cluster_votes_vue.php"

          //const clusterVoteUrl = "https://www.reviewstream.com/reviews/cluster_votes_vue.php"


        try{

             let clusterVotePostResponse
             let clusterVotePostResponseData
             const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ cluster: cluster, vote: vote })
             };
 
             clusterVotePostResponse = await fetch(clusterVoteUrl, requestOptions)
             clusterVotePostResponseData = await clusterVotePostResponse.json()
             let clusterVoteReply = JSON.stringify(clusterVotePostResponseData)

             //console.log('clusterVoteReply '+clusterVoteReply)
    
              if(clusterVoteReply == 1){
                //console.log('votes')
                  let clusterUpdateVote = document.getElementById('cluster-vote-'+cluster)
                  let currentClusterVoteNum = parseInt(clusterUpdateVote.innerHTML)

                  if(vote == "1"){
                    clusterUpdateVote.innerHTML = (currentClusterVoteNum+1) 
                  }
                  if(vote == "2"){
                    clusterUpdateVote.innerHTML = (currentClusterVoteNum-1) 
                  }
              }


          } 
          catch(err) {
            //console.log(err) // state-of-the-art-error-handling
          }

      },
      submitComment: async (id,addedComments,relationId, summary_num,summaryCommentFormShown,summaryCommentGreetingShown, summaryCommentGreetingCurrent) =>{

           //console.log('!!! id: '+id+' ... relation: '+relationId);

            const commentUrl = "../reviews/questions_answers_vue.php"

            //const commentUrl = "https://www.reviewstream.com/reviews/questions_answers_vue.php"


            let commentTxt, commentAuthor, commentAuthorEmail
            let commentTxtInput, commentAuthorInput
            

            if(relationId){    //reply to other comment
             commentTxtInput = document.getElementById('comment-input-'+relationId)
             commentAuthorInput = document.getElementById('comment-author-input-'+relationId)
             commentTxt = document.getElementById('comment-input-'+relationId).value.trim();
             commentAuthor = document.getElementById('comment-author-input-'+relationId).value.trim();
             commentAuthorEmail = document.getElementById('comment-author-email-input-'+relationId).value.trim();
            }
            else if(summary_num>0){     //summary comment
             commentTxtInput = document.getElementById('comment-input-'+id+'-sum-'+summary_num)
             commentAuthorInput = document.getElementById('comment-author-input-'+id+'-sum-'+summary_num)
             commentTxt = document.getElementById('comment-input-'+id+'-sum-'+summary_num).value.trim();
             commentAuthor = document.getElementById('comment-author-input-'+id+'-sum-'+summary_num).value.trim();
             commentAuthorEmail = document.getElementById('comment-author-email-input-'+id+'-sum-'+summary_num).value.trim();
            }
            else{              //comment to the whole review from the main comment form
             commentTxtInput = document.getElementById('comment-input-'+id)
             commentAuthorInput = document.getElementById('comment-author-input-'+id)
             commentTxt = document.getElementById('comment-input-'+id).value.trim();
             commentAuthor = document.getElementById('comment-author-input-'+id).value.trim();
             commentAuthorEmail = document.getElementById('comment-author-email-input-'+id).value.trim();
            }
           
      
        
           if(!commentTxt || !commentAuthor){
             if(!commentTxt){
               commentTxtInput.style.background = '#ffff66'
               setTimeout(function(){commentTxtInput.style.background = '#ffffff'},1000)
               
             }
            if(!commentAuthor){
               commentAuthorInput.style.background = '#ffff66'
               setTimeout(function(){commentAuthorInput.style.background = '#ffffff'},1000)
               
             }

             return
           }
           else{


            //console.log('relation: '+relationId+'...submit comment '+id+'...commentTxt: '+commentTxt+'... urlyy:'+commentUrl);
      

                try{


                    let commentPostResponse
                    let commentPostResponseData
                    const requestOptions = {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ review_id: id, txt: commentTxt, name: commentAuthor, email: commentAuthorEmail, relation:relationId, sumquote:summary_num })
                    };
                    
                    
                    
                    commentPostResponse = await fetch(commentUrl, requestOptions)
                    commentPostResponseData = await commentPostResponse.json()
                    let commentReply = JSON.stringify(commentPostResponseData)
                    
                    let commentResponseText = ''
                    

                    

                    if(commentReply == 1){   //error
                      commentResponseText = 'Oops, something went wrong. Sorry for the inconvenience.'
                    }
                    if(commentReply == 5){  //review author comment
                        commentResponseText = 'Thank you <img src="../images/smiley_message.png" width=16 height=16 alt="smiley" title="smiley" loading="lazy"><br>Every comment increases your Trust Score.'
                    }
                    if(commentReply == 55){  //comment to review
                        commentResponseText = 'Thank you <img src="../images/smiley_message.png" width=16 height=16 alt="smiley" title="smiley" loading="lazy"><br>We appreciate your effort to make an Internet more informative. The review&#39;s author was notified about your message. We suggest you to bookmark this page to follow conversation.'
                    }
                    if(commentReply == 555){  //reply to another comment
                        commentResponseText = 'Thank you <img src="../images/smiley_message.png" width=16 height=16 alt="smiley" title="smiley" loading="lazy"><br>We appreciate your effort to make an Internet more informative. The review&#39;s and comment&#39;s authors were notified about your message. We suggest you to bookmark this page to follow conversation.'
                    }
                    
                  
                    if(summary_num>0){   //should be here, because of the input check above
                      let summaryTxt = '<span id="comment_quote">re : '+document.getElementById('summary-'+summary_num+'-txt').textContent+'</span><br>'
                      commentTxt = summaryTxt + commentTxt
                    }
        
                      let newCommentDetails = {}
                      newCommentDetails.author = commentAuthor
                      newCommentDetails.newcomment = commentTxt
                      newCommentDetails.post_id = id
                      newCommentDetails.relation_id = relationId
                      newCommentDetails.greetingMsg = commentResponseText
              
                      addedComments.push(newCommentDetails)

                      //console.log('addedComments '+addedComments)

                      if(relationId !=''){
                        let newReplyBlck = document.getElementById('addReplyCommentBlck-'+relationId)
                        fade(newReplyBlck)

                        let repliedBtn = document.getElementById('reply-btn-'+relationId)
                        repliedBtn.innerText = 'Replied'
                        repliedBtn.style.background='#ffffff'
                        repliedBtn.style.color='#192f97'


                      }


                      document.getElementById("comment-input-"+id).value = ''
                      commentResponseText = ''



                  } 
                  catch(err) {
                    console.log(err) // state-of-the-art-error-handling
                  }

        }
          //close summary comment form, that was just submitted
          if(summary_num>0){

            for(let i=0;i<summaryCommentFormShown.length;i++){
               //console.log('SHOW tut.. '+summaryCommentFormShown[i].review_id)
               //console.log('SHOW tut... '+summaryCommentFormShown[i].summary_num)
               if(summaryCommentFormShown[i].review_id === id && summaryCommentFormShown[i].summary_num === summary_num){
                 //console.log('SHOW tut 1')
                 summaryCommentFormShown.splice(i, 1);
               }
            }
          //let currentSummaryCommentGreeting = {'summary': id+'-'+summary_num,'greeting':this.showSummaryCommentGreeting(this.summaryCommentGreetingAll,this.summaryCommentGreetingToShow)}
          
          //console.log('currentSummaryCommentGreeting '+currentSummaryCommentGreeting) 

          summaryCommentGreetingShown.push({'summary': id+'-'+summary_num,'greeting':summaryCommentGreetingCurrent})

          console.log('summaryCommentGreetingShown '+JSON.stringify(summaryCommentGreetingShown))
          }
         
      }
 


   }

  })

 </script>
